import { MiniAppSession } from '@/types/miniApp';

const SESSION_DURATION = 7 * 24 * 60 * 60 * 1000; // 7 days

export const miniAppSessionService = {
  saveSession: (appId: string): void => {
    const session: MiniAppSession = {
      appId,
      lastLoginTime: Date.now(),
      sessionExpiry: Date.now() + SESSION_DURATION
    };
    localStorage.setItem(`miniapp_session_${appId}`, JSON.stringify(session));
  },

  getSession: (appId: string): MiniAppSession | null => {
    const saved = localStorage.getItem(`miniapp_session_${appId}`);
    if (!saved) return null;
    
    try {
      return JSON.parse(saved);
    } catch {
      return null;
    }
  },

  isSessionValid: (appId: string): boolean => {
    const session = miniAppSessionService.getSession(appId);
    if (!session) return false;
    
    if (Date.now() > session.sessionExpiry) {
      miniAppSessionService.clearSession(appId);
      return false;
    }
    return true;
  },

  clearSession: (appId: string): void => {
    localStorage.removeItem(`miniapp_session_${appId}`);
  },

  clearAllSessions: (): void => {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('miniapp_session_')) {
        localStorage.removeItem(key);
      }
    });
  }
};
